import { useCallback, useRef, useState, useEffect } from 'react';
import { useCallbackRef } from './useCallbackRef';
function useControllable({
  prop,
  defaultProp,
  onChange
}) {
  const [uncontrolledProp, setUncontrolledProp] = useUncontrolled({
    defaultProp,
    onChange
  });
  const isControlled = prop !== undefined;
  const value = isControlled ? prop : uncontrolledProp;
  const handleChange = useCallbackRef(onChange);
  const setValue = useCallback(nextValue => {
    if (isControlled) {
      const computedValue = typeof nextValue === 'function' ? nextValue(prop) : nextValue;
      if (computedValue !== prop) {
        handleChange(computedValue);
      }
    } else {
      setUncontrolledProp(nextValue);
    }
  }, [isControlled, prop, handleChange, setUncontrolledProp]);
  return [value, setValue];
}
function useUncontrolled({
  defaultProp,
  onChange
}) {
  const uncontrolledState = useState(defaultProp);
  const [value] = uncontrolledState;
  const prevValueRef = useRef(value);
  const handleChange = useCallbackRef(onChange);
  useEffect(() => {
    if (prevValueRef.current !== value) {
      handleChange(value);
      prevValueRef.current = value;
    }
  }, [value, prevValueRef, handleChange]);
  return uncontrolledState;
}
export { useControllable };